import { create } from "zustand"
import extractISODate from "../utils/extract-iso-date"
import { addDays, endOfWeek, isMonday, startOfWeek } from "date-fns"

interface CalendarConfigState {
  ranges: {
    startDate: string
    endDate: string
    startTime: string
    endTime: string
  }
  step: 15 | 30 | 40 | 45 | 60
  format: 12 | 24
  currentDate: string
  currentWeek: {
    startDate: string
    endDate: string
  }
}

interface CalendarConfigActions {
  setCurrentDate: (date: string) => void
  setCurrentWeek: (dateRef: string) => void
  setRanges: (rangesInfo: CalendarConfigState["ranges"]) => void
}

const initialState: CalendarConfigState = {
  ranges: {
    startDate: "",
    endDate: "",
    startTime: "",
    endTime: "",
  },
  step: 30,
  format: 12,
  currentDate: "",
  currentWeek: {
    startDate: "",
    endDate: "",
  },
}

const useCalendarConfig = create<CalendarConfigState & CalendarConfigActions>()((set) => ({
  ...initialState,
  setCurrentDate: (date) => set({ currentDate: date }),
  setCurrentWeek: (dateRef) => {
    const date = new Date(dateRef)
    const adjustedDate = isMonday(date) ? addDays(date, 1) : date

    const newStartDate = extractISODate(startOfWeek(adjustedDate, { weekStartsOn: 1 }))
    const newEndDate = extractISODate(endOfWeek(adjustedDate, { weekStartsOn: 1 }))

    set({
      currentWeek: {
        startDate: newStartDate,
        endDate: newEndDate,
      },
    })
  },
  setRanges: (rangesInfo) => set({ ranges: rangesInfo }),
}))

export default useCalendarConfig
